module.exports = __webpack_public_path__ + "assets/img/index-leftmenu-bg.89563625.png";